'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {};
}

var DeleteSelectedButtonCells = function (_Component) {
    (0, _inherits3.default)(DeleteSelectedButtonCells, _Component);

    function DeleteSelectedButtonCells() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DeleteSelectedButtonCells);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeleteSelectedButtonCells.__proto__ || (0, _getPrototypeOf2.default)(DeleteSelectedButtonCells)).call.apply(_ref, [this].concat(args))), _this), _this.deleteBatch = function () {
            _this.props.deleteBatch();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DeleteSelectedButtonCells, [{
        key: 'render',
        value: function render() {
            var anyItemSelected = this.props.cart.items.some(function (s) {
                return s.selectedRow;
            });
            return anyItemSelected ? _react2.default.createElement(
                'td',
                { colSpan: '3' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-footer' },
                    _react2.default.createElement(
                        'div',
                        { className: 'pull-right' },
                        _react2.default.createElement(
                            'a',
                            { onClick: this.deleteBatch, className: 'btn btn-danger' },
                            _react2.default.createElement('i', { className: 'fa fa-remove' }),
                            ' \xA0 ',
                            (0, _localize2.default)("App:DeleteSelected")
                        )
                    )
                )
            ) : _react2.default.createElement('td', { colSpan: '3' });
        }
    }]);
    return DeleteSelectedButtonCells;
}(_react.Component);

DeleteSelectedButtonCells.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    deleteBatch: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    deleteBatch: _actions2.default.deleteBatch
})(DeleteSelectedButtonCells);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/DeleteSelectedButtonCells.js
// module id = 593
// module chunks = 0